import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { StoreProvider } from 'store/Provider.tsx'
import App from './App.tsx'
import './index.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <StoreProvider>
      <App />
    </StoreProvider>
  </StrictMode>
)
